module.exports = __webpack_public_path__ + "static/usatbestfoodyet-62c3f877afa0b00839bf295d4b697af5.jpg";